import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { WorkspaceProvider } from './context/WorkspaceContext';
import { DashboardLayout } from './components/layout/DashboardLayout';
import { LandingPage } from './components/landing/LandingPage';
import { OverviewPage } from './components/dashboard/OverviewPage';
import { BookkeepingPage } from './components/bookkeeping/BookkeepingPage';
import { GSTPage } from './components/gst/GSTPage';
import { BillsPage } from './components/bills/BillsPage';

const ReceivablesPage = lazy(() =>
  import('./components/dashboard/ReceivablesPage').then((m) => ({ default: m.ReceivablesPage }))
);
const PayablesPage = lazy(() =>
  import('./components/dashboard/PayablesPage').then((m) => ({ default: m.PayablesPage }))
);
const MISReportPage = lazy(() =>
  import('./components/mis/MISReportPage').then((m) => ({ default: m.MISReportPage }))
);
const UnitEconomicsPage = lazy(() =>
  import('./components/mis/UnitEconomicsPage').then((m) => ({ default: m.UnitEconomicsPage }))
);
const EcomKPIsPage = lazy(() =>
  import('./components/mis/EcomKPIsPage').then((m) => ({ default: m.EcomKPIsPage }))
);
const CashForecastPage = lazy(() =>
  import('./components/forecast/CashForecastPage').then((m) => ({ default: m.CashForecastPage }))
);
const InventoryPage = lazy(() =>
  import('./components/inventory/InventoryPage').then((m) => ({ default: m.InventoryPage }))
);
const FinanceCalendarPage = lazy(() =>
  import('./components/calendar/FinanceCalendarPage').then((m) => ({ default: m.FinanceCalendarPage }))
);

function LazyWrap({ children }) {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-[40vh] items-center justify-center text-slate-500">Loading…</div>
      }
    >
      {children}
    </Suspense>
  );
}

export default function App() {
  return (
    <WorkspaceProvider>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/bookkeeping" element={<BookkeepingPage />} />
        <Route path="/gst" element={<GSTPage />} />
        <Route path="/bills" element={<BillsPage />} />
        <Route path="/mis" element={<LazyWrap><MISReportPage /></LazyWrap>} />
        <Route path="/unit-economics" element={<LazyWrap><UnitEconomicsPage /></LazyWrap>} />
        <Route path="/kpis" element={<LazyWrap><EcomKPIsPage /></LazyWrap>} />
        <Route path="/cash-forecast" element={<LazyWrap><CashForecastPage /></LazyWrap>} />
        <Route path="/inventory" element={<LazyWrap><InventoryPage /></LazyWrap>} />
        <Route path="/finance-calendar" element={<LazyWrap><FinanceCalendarPage /></LazyWrap>} />
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<OverviewPage />} />
          <Route
            path="receivables"
            element={
              <LazyWrap>
                <ReceivablesPage />
              </LazyWrap>
            }
          />
          <Route
            path="payables"
            element={
              <LazyWrap>
                <PayablesPage />
              </LazyWrap>
            }
          />
        </Route>
      </Routes>
    </WorkspaceProvider>
  );
}
